import { Node } from '@alfresco/js-api';
import { isLibrary, isLocked } from '@alfresco/aca-shared';

export function isLockedNode(node: { entry: Node }): boolean {
  return isLocked(node);
}

export function isLibraryNode(node: { entry: Node | any }): boolean {
  return isLibrary(node);
}

export function cloneNode(node) {
  const dummyPathElements = node.entry.path?.elements.map((obj) => {
    return { ...obj };
  });
  const dummyPath = { ...node.entry.path };
  const dummyEntry = { ...node.entry };
  const dummyNode = { ...node };
  dummyPath.elements = dummyPathElements;
  dummyEntry.path = dummyPath;
  dummyNode.entry = dummyEntry;
  return dummyNode;
}
